module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "C146"
  }, [_c('p', {
    staticClass: "C145"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('img', {
    staticClass: "img80",
    attrs: {
      "alt": "",
      "src": "html/images/15_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "P3"
  }, [_vm._v("Map of Greece by András Bereznay")])])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92d8aa32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/08_MAP.vue
// module id = 78
// module chunks = 0